/* eslint-disable */ 
import React, { useEffect, useState } from 'react'
import Body from './Body'
import "../../../../styles/Pages/Organizational/Management/Staffs/Staffs.style.css"
const Staffs = () => {
    const [addMemberModal, setAddMemberModal] = useState(false)

    const [staffAttendance, setStaffAttendance] = useState([
        { name: 'Security', color: "#0088FE", totalPerson: "20", totalAttandence: "12" },
        { name: 'Food staffs', color: "#00C49F", totalPerson: "35", totalAttandence: "16" },
        { name: 'Sweeper', color: "#FFBB28", totalPerson: "25", totalAttandence: "18" },
        { name: 'Clerks', color: "#FF8042", totalPerson: "30", totalAttandence: "29" },
        { name: 'Teachers', color: "#FF0000", totalPerson: "40", totalAttandence: "20" },
        { name: 'Others', color: "#800080", totalPerson: "15", totalAttandence: "10" },
    ]);


    const [staffsAttendanceColors, setStaffsAttendanceColors] = useState([
        { colorFor: 'Security', fontColor: "#85BF52", backgroundColor: "#F9FFF3" },
        { colorFor: 'Food staffs', fontColor: "#E54EE0", backgroundColor: "#FEF3FF" },
        { colorFor: 'Sweeper', fontColor: "#43BCC9", backgroundColor: "#F0FEFF" },
        { colorFor: 'Clerks', fontColor: "#DFBE19", backgroundColor: "#FFFDF1" },
        { colorFor: 'Teachers', fontColor: "#FF8266", backgroundColor: "#FFECEC" },
        { colorFor: 'Others', fontColor: "#516BFF", backgroundColor: "#F0F2FF" },
    ]);

    useEffect(() => {
        const mappedStaffAttendance = staffAttendance.map(staff => {
            const colorInfo = staffsAttendanceColors.find(color => color.colorFor === staff.name);
            return {
                ...staff,
                backgroundColor: colorInfo ? colorInfo.backgroundColor : null, // Default to null if no color is found
                color: colorInfo ? colorInfo.fontColor : null, // Default to null if no color is found
            };
        });
        setStaffAttendance(mappedStaffAttendance && mappedStaffAttendance)
    }, [])


    const _this = { staffAttendance, staffsAttendanceColors, addMemberModal, setAddMemberModal }
    return (
        <Body {..._this} />
    )
}

export default Staffs